export default __webpack_public_path__ + "static/thumb-landscape-623c994770f6c250d4e334386a26f99a.jpg";